import type { ChatMessage } from '../types';

/** Text the server persists for a text_to_image reply whose image is stored as a generated file. */
const GENERATED_IMAGE_PLACEHOLDER = 'generated image';

type Attachments = ChatMessage['attachments'];

const hasImageAttachment = (attachments: Attachments) =>
  Boolean(attachments?.some((attachment) => attachment.mimeType.startsWith('image/')));

/** The image already renders from its attachment, so the placeholder caption is dropped. */
export const stripGeneratedImagePlaceholder = (content: string, attachments: Attachments) =>
  content.trim().toLowerCase() === GENERATED_IMAGE_PLACEHOLDER && hasImageAttachment(attachments)
    ? ''
    : content;

/**
 * True while a routed text_to_image turn has not finished yet. The stream sets `capability` once
 * routing picks it; completion adds `isImage` (plus `finishReason` on the live stream) and failure
 * adds `error`.
 */
export const isImageGenerationPending = (metadata: unknown, attachments: Attachments) => {
  if (!metadata || typeof metadata !== 'object') return false;
  const record = metadata as Record<string, unknown>;
  return (
    record.capability === 'text_to_image' &&
    record.finishReason === undefined &&
    record.isImage === undefined &&
    record.error === undefined &&
    !hasImageAttachment(attachments)
  );
};

export const hasGeneratedMediaQuotaImpact = (metadata: unknown) => {
  if (!metadata || typeof metadata !== 'object') return false;
  const record = metadata as Record<string, unknown>;
  return (
    record.isImage === true ||
    (Array.isArray(record.generatedFiles) && record.generatedFiles.length > 0)
  );
};
